
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3RuW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8beccc9b9089945d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $lcuZm = parcelRequire("lcuZm");
var $9fSoV = parcelRequire("9fSoV");

var $6uCbI = parcelRequire("6uCbI");

var $1V0vS = parcelRequire("1V0vS");

var $fqOx0 = parcelRequire("fqOx0");

var $lmf9C = parcelRequire("lmf9C");
function $8beccc9b9089945d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8beccc9b9089945d$var$DEFAULT_WIDTH = 250;
const $8beccc9b9089945d$var$DEFAULT_HEIGHT = 200;
const $8beccc9b9089945d$var$uiMediaSingleBaseStyles = {
    name: "1a43hhz",
    styles: "transition:all 0.1s linear"
};
const $8beccc9b9089945d$var$uiMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
const $8beccc9b9089945d$var$isMediaElement = (media)=>{
    if (!media) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { nodeType: nodeType, type: type } = media.props || {};
    // Use this to perform a rough check
    // better than assume the first item in children is media
    return nodeType === 'media' || [
        'external',
        'file',
        'link'
    ].indexOf(type) >= 0;
};
const $8beccc9b9089945d$var$checkForMediaElement = (children)=>{
    const [media] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (media && !$8beccc9b9089945d$var$isMediaElement(media) && media.props.children) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $8beccc9b9089945d$var$checkForMediaElement(media.props.children);
    return media;
};
const $8beccc9b9089945d$export$507465eaf3c57f05 = (currentContainerWidth, layout)=>{
    if (!currentContainerWidth) // SSR mode fallback to default layout width
    switch(layout){
        case 'full-width':
            return 0, $6uCbI.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $6uCbI.akEditorWideLayoutWidth;
        default:
            return 0, $6uCbI.akEditorDefaultLayoutWidth;
    }
    return currentContainerWidth;
};
const $8beccc9b9089945d$var$MediaSingleWithChildren = (props)=>{
    const { rendererAppearance: rendererAppearance, featureFlags: featureFlags, isInsideOfBlockNode: isInsideOfBlockNode, layout: layout, width: widthAttr, widthType: widthType, allowCaptions: allowCaptions = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, media: media, caption: caption, editorAppearance: editorAppearance } = props;
    const [externalImageDimensions, setExternalImageDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        width: 0,
        height: 0
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const onExternalImageLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(({ width: width, height: height })=>{
        setExternalImageDimensions({
            width: width,
            height: height
        });
    }, []);
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { width: width = $8beccc9b9089945d$var$DEFAULT_WIDTH, height: height = $8beccc9b9089945d$var$DEFAULT_HEIGHT, type: type } = media.props;
    if (type === 'external') {
        const { width: stateWidth, height: stateHeight } = externalImageDimensions;
        if (width === null) width = stateWidth || $8beccc9b9089945d$var$DEFAULT_WIDTH;
        if (height === null) height = stateHeight || $8beccc9b9089945d$var$DEFAULT_HEIGHT;
    }
    if (width === null) {
        width = $8beccc9b9089945d$var$DEFAULT_WIDTH;
        height = $8beccc9b9089945d$var$DEFAULT_HEIGHT;
    }
    const isFullPage = rendererAppearance === 'full-page';
    const isFullWidth = rendererAppearance === 'full-width';
    const padding = isFullPage ? (0, $1V0vS.FullPagePadding) * 2 : 0;
    const calcDimensions = (0, $5uXOq.useCallback)((mediaContainerWidth)=>{
        const containerWidth = $8beccc9b9089945d$export$507465eaf3c57f05(mediaContainerWidth, layout);
        const maxWidth = containerWidth;
        const maxHeight = height / width * maxWidth;
        const cardDimensions = {
            width: `${maxWidth}px`,
            height: `${maxHeight}px`
        };
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $6uCbI.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $6uCbI.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const minWidth = Math.min((0, $6uCbI.akEditorFullWidthLayoutWidth), containerWidth - padding);
        const lineLength = isFullWidth ? minWidth : nonFullWidthSize;
        return {
            cardDimensions: cardDimensions,
            lineLength: lineLength
        };
    }, [
        height,
        isFullWidth,
        isInsideOfBlockNode,
        layout,
        padding,
        rendererAppearance,
        width
    ]);
    const originalDimensions = (0, $5uXOq.useMemo)(()=>({
            width: width,
            height: height
        }), [
        height,
        width
    ]);
    const { setHoverTarget: setHoverTarget } = (0, $fqOx0.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $lmf9C.useAnnotationHoverDispatch)();
    const isFullPageRenderer = isFullPage || isFullWidth;
    (0, $5uXOq.useEffect)(()=>{
        const mediaSingleElement = ref.current;
        const handleMouseEnter = (event)=>{
            cancelTimeout();
            if (event.buttons === 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                setHoverTarget && setHoverTarget(event.target);
                setIsWithinRange(true);
            }
        };
        const handleMouseLeave = ()=>{
            initiateTimeout();
        };
        if (mediaSingleElement && isFullPageRenderer) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseenter', handleMouseEnter);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return ()=>{
            if (mediaSingleElement && isFullPageRenderer) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseenter', handleMouseEnter);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [
        setHoverTarget,
        isFullPageRenderer,
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    // Note: in SSR mode the `window` object is not defined,
    // therefore width here is 0, see:
    // packages/editor/editor-common/src/ui/WidthProvider/index.tsx
    const { width: renderWidth } = (0, $5uXOq.useContext)((0, $9fSoV.WidthContext));
    const containerWidth = $8beccc9b9089945d$export$507465eaf3c57f05(renderWidth, layout);
    const { cardDimensions: cardDimensions, lineLength: lineLength } = (0, $5uXOq.useMemo)(()=>calcDimensions(containerWidth), [
        calcDimensions,
        containerWidth
    ]);
    const renderMediaSingle = ()=>{
        const mediaComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(media, {
            resizeMode: 'stretchy-fit',
            cardDimensions: cardDimensions,
            originalDimensions: originalDimensions,
            onExternalImageLoaded: onExternalImageLoaded,
            disableOverlay: true,
            featureFlags: featureFlags,
            mediaSingleElement: ref.current
        });
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? [
            $8beccc9b9089945d$var$uiMediaSingleBaseStyles,
            $8beccc9b9089945d$var$uiMediaSingleLayoutStyles
        ] : [
            $8beccc9b9089945d$var$uiMediaSingleBaseStyles
        ];
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lcuZm.default), {
            css: uiMediaSingleStyles,
            handleMediaSingleRef: ref,
            layout: layout,
            width: width,
            height: height,
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            containerWidth: containerWidth,
            size: {
                width: widthAttr,
                widthType: widthType
            },
            fullWidthMode: isFullWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            dataAttributes: dataAttributes,
            editorAppearance: editorAppearance
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mediaComponent), allowCaptions && caption);
    };
    return renderMediaSingle();
};
const $8beccc9b9089945d$var$MediaSingle = (props)=>{
    const { children: children } = props;
    let media;
    const [node, caption] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
    if (!$8beccc9b9089945d$var$isMediaElement(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mediaElement = $8beccc9b9089945d$var$checkForMediaElement(node.props.children);
        if (!mediaElement) return node;
        media = mediaElement;
    } else media = node;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($8beccc9b9089945d$var$MediaSingleWithChildren, {
        ...props,
        media: media,
        caption: caption
    });
};
var $8beccc9b9089945d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($8beccc9b9089945d$var$MediaSingle);

});
parcelRegister("lcuZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $36dcaefaf406bc07$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ci4W = parcelRequire("9ci4W");

var $6uCbI = parcelRequire("6uCbI");

var $fHpHg = parcelRequire("fHpHg");

var $ij163 = parcelRequire("ij163");

var $goc5e = parcelRequire("goc5e");

var $dfCof = parcelRequire("dfCof");

var $aovP1 = parcelRequire("aovP1");
function $36dcaefaf406bc07$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $dfCof.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $goc5e.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $6uCbI.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $6uCbI.DEFAULT_EMBED_CARD_WIDTH) - (0, $6uCbI.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $aovP1.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension
        }),
        ...(0, $fHpHg.fg)('platform_fix_media_image_resizing') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9ci4W)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aovP1.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("9ci4W", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("ij163", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $a388bdbaeca450fe$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $a388bdbaeca450fe$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $a388bdbaeca450fe$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $a388bdbaeca450fe$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $a388bdbaeca450fe$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $a388bdbaeca450fe$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $a388bdbaeca450fe$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $a388bdbaeca450fe$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $a388bdbaeca450fe$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $a388bdbaeca450fe$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $a388bdbaeca450fe$export$b4b560efd3c61856);
const $a388bdbaeca450fe$export$5937600f4cc784f0 = 24;
const $a388bdbaeca450fe$export$71d660e8ca5b8f73 = 320;
const $a388bdbaeca450fe$export$cd11d7d46412c89b = 3;
const $a388bdbaeca450fe$export$71482734bb54ac3 = 10;
const $a388bdbaeca450fe$export$fd2b09475ada41cc = 12;
const $a388bdbaeca450fe$export$8c5ac0b0c62a3d21 = 8;
const $a388bdbaeca450fe$export$68d0abe4f03863fb = $a388bdbaeca450fe$export$fd2b09475ada41cc * 2;
const $a388bdbaeca450fe$export$d722b7527b1834a8 = 250;
const $a388bdbaeca450fe$export$da894f7669b4e67c = 200;
const $a388bdbaeca450fe$export$e13825c38da2ce1 = 100;
var $a388bdbaeca450fe$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $a388bdbaeca450fe$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $a388bdbaeca450fe$export$4d41d008e9cd4f34 = 0.5;
const $a388bdbaeca450fe$export$b4b560efd3c61856 = 'caption-placeholder';

});

parcelRegister("goc5e", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $3a0a5fde2c68ceae$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $3a0a5fde2c68ceae$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $3a0a5fde2c68ceae$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $3a0a5fde2c68ceae$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $3a0a5fde2c68ceae$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $3a0a5fde2c68ceae$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $3a0a5fde2c68ceae$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $3a0a5fde2c68ceae$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $3a0a5fde2c68ceae$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $3a0a5fde2c68ceae$export$22e4c8c04f58169d);

var $gZGBX = parcelRequire("gZGBX");

var $6uCbI = parcelRequire("6uCbI");

var $dfCof = parcelRequire("dfCof");

var $ij163 = parcelRequire("ij163");
function $3a0a5fde2c68ceae$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $3a0a5fde2c68ceae$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $3a0a5fde2c68ceae$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $3a0a5fde2c68ceae$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $ij163.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $3a0a5fde2c68ceae$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $3a0a5fde2c68ceae$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $6uCbI.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $3a0a5fde2c68ceae$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullWidthPadding = editorAppearance === 'full-page' ? (0, $6uCbI.akEditorGutterPaddingDynamic)() * 2 : (0, $6uCbI.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $6uCbI.akEditorFullWidthLayoutWidth));
};
const $3a0a5fde2c68ceae$export$4ab195f543459515 = (origWidth = (0, $ij163.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $6uCbI.akEditorDefaultLayoutWidth), minWidth = (0, $ij163.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $3a0a5fde2c68ceae$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $3a0a5fde2c68ceae$export$f72673597dacfcfa = (value, interval = (0, $ij163.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $3a0a5fde2c68ceae$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $ij163.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $ij163.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $3a0a5fde2c68ceae$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $dfCof.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $dfCof.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $3a0a5fde2c68ceae$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $3a0a5fde2c68ceae$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $3a0a5fde2c68ceae$export$7cc71489edfd26f8($pos, view) : $3a0a5fde2c68ceae$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $3a0a5fde2c68ceae$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $dfCof.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $3a0a5fde2c68ceae$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $3a0a5fde2c68ceae$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $3a0a5fde2c68ceae$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $3a0a5fde2c68ceae$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $gZGBX.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});
parcelRegister("dfCof", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $a8b5e9911b9b8637$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $a8b5e9911b9b8637$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $a8b5e9911b9b8637$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $a8b5e9911b9b8637$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $a8b5e9911b9b8637$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $a8b5e9911b9b8637$export$de65085e667b4bf1);

var $5r0mK = parcelRequire("5r0mK");

var $6uCbI = parcelRequire("6uCbI");

var $bjuHb = parcelRequire("bjuHb");
const $a8b5e9911b9b8637$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $bjuHb.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $a8b5e9911b9b8637$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $a8b5e9911b9b8637$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $a8b5e9911b9b8637$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $a8b5e9911b9b8637$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $a8b5e9911b9b8637$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $a8b5e9911b9b8637$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $bjuHb.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $bjuHb.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $a8b5e9911b9b8637$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $a8b5e9911b9b8637$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $bjuHb.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $bjuHb.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $6uCbI.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("bjuHb", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $7f5dcc9fefae8fb1$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $7f5dcc9fefae8fb1$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $7f5dcc9fefae8fb1$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $7f5dcc9fefae8fb1$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $7f5dcc9fefae8fb1$export$5e51fc02b9ada5af);

var $6uCbI = parcelRequire("6uCbI");

var $ij163 = parcelRequire("ij163");
const $7f5dcc9fefae8fb1$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $7f5dcc9fefae8fb1$export$adfc02948d64a4f2 = (layout)=>$7f5dcc9fefae8fb1$var$validWidthModes.indexOf(layout) > -1;
function $7f5dcc9fefae8fb1$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7f5dcc9fefae8fb1$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $7f5dcc9fefae8fb1$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7f5dcc9fefae8fb1$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $ij163.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $7f5dcc9fefae8fb1$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $7f5dcc9fefae8fb1$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($7f5dcc9fefae8fb1$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $7f5dcc9fefae8fb1$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $7f5dcc9fefae8fb1$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $7f5dcc9fefae8fb1$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $6uCbI.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $6uCbI.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($7f5dcc9fefae8fb1$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $7f5dcc9fefae8fb1$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $7f5dcc9fefae8fb1$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $7f5dcc9fefae8fb1$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($7f5dcc9fefae8fb1$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $7f5dcc9fefae8fb1$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});



parcelRegister("aovP1", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $080596c6fadb1bbf$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $080596c6fadb1bbf$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $080596c6fadb1bbf$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6uCbI = parcelRequire("6uCbI");

var $fHpHg = parcelRequire("fHpHg");

var $dfCof = parcelRequire("dfCof");

var $d5uD2 = parcelRequire("d5uD2");
function $080596c6fadb1bbf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $080596c6fadb1bbf$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $080596c6fadb1bbf$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $6uCbI.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $6uCbI.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $6uCbI.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $080596c6fadb1bbf$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $6uCbI.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $6uCbI.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $6uCbI.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $080596c6fadb1bbf$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $d5uD2.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $d5uD2.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $d5uD2.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $080596c6fadb1bbf$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $080596c6fadb1bbf$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $080596c6fadb1bbf$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $d5uD2.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $d5uD2.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $080596c6fadb1bbf$var$getWidthIfFullWidthMode(width, containerWidth) : $080596c6fadb1bbf$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $080596c6fadb1bbf$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $d5uD2.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $d5uD2.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $080596c6fadb1bbf$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $d5uD2.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $d5uD2.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $080596c6fadb1bbf$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $080596c6fadb1bbf$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $080596c6fadb1bbf$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 */ var $080596c6fadb1bbf$var$_ref = {
    name: "1ejvwbh",
    styles: "@container view-page-content (min-width: 1px){max-width:100cqw;}"
};
var $080596c6fadb1bbf$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $080596c6fadb1bbf$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false })=>{
    const calculatedWidth = $080596c6fadb1bbf$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $080596c6fadb1bbf$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $080596c6fadb1bbf$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $080596c6fadb1bbf$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $080596c6fadb1bbf$var$calcMaxWidth(layout, containerWidth));
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $080596c6fadb1bbf$var$_ref2, " ", isExtendedResizeExperienceOn && (0, $fHpHg.fg)('platform_fix_media_image_resizing') ? $080596c6fadb1bbf$var$_ref : '', "max-width:", calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $dfCof.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $080596c6fadb1bbf$var$float(layout), ";margin:", $080596c6fadb1bbf$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $dfCof.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $080596c6fadb1bbf$var$isImageAligned(layout), ";");
};
const $080596c6fadb1bbf$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $f8Sb3.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $080596c6fadb1bbf$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $f8Sb3.css)("position:relative;", $080596c6fadb1bbf$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $080596c6fadb1bbf$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $080596c6fadb1bbf$export$9e3fd9f6215dd7b6(rest)
    }, children);
$080596c6fadb1bbf$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $080596c6fadb1bbf$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});




//# sourceMappingURL=mediaSingle.fcf9fa63.js.map
